export default "__VITE_ASSET__CsY3JP25__"